import React, { useEffect, useState } from "react";
import "./assets/scss/themes.scss";
import "./assets/scss/layer.scss";
import "./assets/scss/mobile-view.scss";
import Route from "./Routes";
import { initFirebaseBackend } from "./helpers/firebase_helper";
import { ToastContainer } from "react-toastify";
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { postRefreshAuth } from "helpers/backend_helper";
import { Constant } from "utils/enums";
import { registerLicense } from "@syncfusion/ej2-base";
import { handleLogout } from "helpers/api_helper";
import { Environment } from "environment";
import io from "socket.io-client";

const userStr = localStorage.getItem(Constant.seller);
const user = userStr ? JSON.parse(userStr) : null;
const userId = user?.sellerId;
var url = `${Environment.socketUrl}?userId=${userId}`
const socket = io(url);
// @ts-ignore
// eslint-disable-next-line import/first
import neworder from "./assets/audio/neworder.mp3";

const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

fakeBackend();
initFirebaseBackend(Environment.firebaseConfig);

function App() {
  useEffect(() => {
    registerLicense(
      "Ngo9BigBOggjHTQxAR8/V1NMaF1cXmhNYVFpR2Nbek5yflVAal1VVAciSV9jS3tTdUVgWX1fcHZXR2JeUg/"
    );
    let refreshToken = localStorage.getItem(Constant.refresh_token);
    if (refreshToken) {
      (async () => {
        try {
          const res: any = await postRefreshAuth();
          if (res && res?.access_token) {
            localStorage.setItem(
              Constant.access_token,
              JSON.stringify(res.access_token)
            );
            localStorage.setItem(
              Constant.refresh_token,
              JSON.stringify(res.refresh_token)
            );
          }
        } catch (error) {
          console.error("Error refreshing token:", error);
          handleLogout();
        }
      })();
    }
  }, []);

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      const accessToken = localStorage.getItem(Constant.access_token);
      const refreshToken = localStorage.getItem(Constant.refresh_token);
      if (!accessToken || !refreshToken) return;

      const decoded = parseJwt(JSON.parse(accessToken));
      const currentTime = Date.now() / 1000;

      if (decoded && decoded.exp < currentTime) {
        try {
          const res: any = await postRefreshAuth();
          if (res?.access_token) {
            localStorage.setItem(
              Constant.access_token,
              JSON.stringify(res.access_token)
            );
            localStorage.setItem(
              Constant.refresh_token,
              JSON.stringify(res.refresh_token)
            );
          }
        } catch (error) {
          console.error("Token refresh failed on tab active:", error);
          handleLogout();
        }
      }
    };

    const handleTabActive = () => {
      if (document.visibilityState === "visible") {
        checkAndRefreshToken();
      }
    };

    document.addEventListener("visibilitychange", handleTabActive);
    return () =>
      document.removeEventListener("visibilitychange", handleTabActive);
  }, []);

  const [userInteracted, setUserInteracted] = useState(false);
  const [audio] = useState(() => new Audio(neworder));

  useEffect(() => {
    const handleInteraction = () => {
      setUserInteracted(true);
      document.removeEventListener("click", handleInteraction);
    };
    document.addEventListener("click", handleInteraction);
    return () => {
      document.removeEventListener("click", handleInteraction);
    };
  }, []);

  useEffect(() => {
    if (!userInteracted) return;
    const handleNewOrder = () => {
      audio.play().catch((err) => {});
    };
    socket.on("getOrderData", handleNewOrder);
    return () => {
      socket.off("getOrderData", handleNewOrder);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInteracted]);

  return (
    <React.Fragment>
      <ToastContainer limit={1} />
      <Route />
    </React.Fragment>
  );
}

export default App;
